import firebase from "firebase";


export async function uploadImage(file, path){
    const storage = firebase.storage()
    const fileRef = storage.ref(`${path}/${file.name}`)
    const snapshot = await fileRef.put(file)
    return await snapshot.ref.getDownloadURL()
}